import React,{Component} from "react";
//import "../../node_modules/react-pro-sidebar/dist/css/styles.css";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import Moment from "moment";
import ModalLogin from './ModalLogin';
import Mymodal from './modal';
import Cookies from "universal-cookie";
import config from '../config';
import logonorecord from "./images/recordnotfound.png";

const cookies = new Cookies();
const axios = require("axios");
export default class LeaveAppList extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
        myitems: [],
        statustext:[],
        revoke:[],
        remove:[],        
        revokepart:[],
        isLoaded: false,
        ErrMsg:<img src={logo} alt="Error"/>,
        ErrMsg2:"",
        today: new Date(),
        DivClass: "ErrDiv"
        }
        this.handlerevoke = this.handlerevoke.bind(this);
        this.handleremove = this.handleremove.bind(this);
        this.handlecancel = this.handlecancel.bind(this);
    }
    handlerevokepartial(id,i){
        let input= this.state.input;
        let myitems = this.state.myitems;
        //console.log(myitems);

        input["formid"]=myitems[i]["id"];
        input["type"]=myitems[i]["leavetype"];
        input["days"]=myitems[i]["leavedays"];
        input["from"]=myitems[i]["from_Date"];
        input["to"]=myitems[i]["to_date"];
        input["applydate"]=myitems[i]["applieddate"];        
        this.setState({input});
        this.props.history.push({
            pathname: '/LeaveRevoke',
            data: this.state.input // your data array of objects
          })
    }    

    handlecancel(id,index){
        this.state.statustext[id];
        document.body.style.cursor="wait";
        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/Cancelleave/'+id,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:""});
            if(response.data === "1")
            {
                let item = this.state.statustext;
                item[index] = <span style={{color:'red'}}>Cancellation pending</span>; 
                this.setState({statustext:item });
                let itemremove = this.state.remove;    
                itemremove[index]="";
                this.setState({remove:itemremove});
            }
            else if(response.data === "0")
            {
                this.setState({DivClass:"ErrDiv"});
                this.setState({ErrMsg2:"Your application might have been cancelled. Refresh/reload your page."});
            }
        })
        .catch((response)=> {
            this.setState({DivClass:"ErrDiv"});
            this.setState({ErrMsg2:"Your request to cancel application is failed, try later please."});

        });      


    }
    handleremove(id,index){
        this.state.statustext[id];
        document.body.style.cursor="wait";

        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/Removeleave/'+id,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:""});
            if(response.data === 1)
            {
                let item = this.state.statustext;
                item[index] = <span style={{color:'red'}}>Deleted</span>; 
                this.setState({statustext:item });
                let itemremove = this.state.remove;    
                itemremove[index]="";
                this.setState({remove:itemremove});
            }
            else if(response.data === 0)
            {
                this.setState({DivClass:"ErrDiv"});
                this.setState({ErrMsg2:"Your application might have been approved or refused. Refresh/reload your page."});
            }
        })
        .catch((response)=> {
            this.setState({DivClass:"ErrDiv"});
            this.setState({ErrMsg2:"Your request to remove application is failed, try later please."});

        });         
    }

    handlerevoke(id,index){
        
        this.state.statustext[id];
        document.body.style.cursor="wait";

        axios({
            method: 'post',
            url: cookies.get("phpclass")+'/index.php/user/Revokeleave/'+id,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:""});
            if(response.data === 1)
            {
                let item = this.state.statustext;
                item[index] = <span style={{color:'blue'}}>Revoked on {Moment(this.state.today).format("DD/MM/YYYY")}</span>; 
                this.setState({statustext:item });
                let itemrevoke = this.state.revoke;    
                itemrevoke[index]="";
                this.setState({revoke:itemrevoke});
            }
            else if(response.data === 0)
            {
                this.setState({DivClass:"ErrDiv"});
                this.setState({ErrMsg2:"Your application might have been approved or refused. Refresh/reload your page."});
            }
        })
        .catch((response)=> {
            this.setState({DivClass:"ErrDiv"});
            this.setState({ErrMsg2:"Your request to revoke application is failed, try later please."});

        });      
    }
    handleClick(claimid){
        let input= this.state.input;
        input["ClaimID"] = claimid;
        this.setState({input});

        this.props.history.push({
            pathname: '/medicalform',
            data: this.state.input // your data array of objects
          })
    }
    cur=(num)=> {
        let cnum=parseInt(num,0);
        if(num > 0)
    
            return num.toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        else
            return "-"
    }
    componentDidMount(){
        if(cookies.get("LoginID"))
        {  
            document.body.style.cursor="wait";
            let loginid = cookies.get("LoginID");                    
            let input=this.state.input;
            input["ID"]=loginid;
            this.setState({input});
            axios({
                method: 'post',
                url: cookies.get("phpclass")+'/index.php/user/leaveapplist/'+loginid,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                document.body.style.cursor="default";
                if(response.data=="1")
                    this.setState({ErrMsg:<img src={logonorecord} alt="Not found"/>});
                else
                    this.setState({isLoaded: true, ErrMsg:"", myitems: response.data
                });
            })
            .catch((response)=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<Mymodal Title={config.gvr.ErrMsgs.TitleNotFound} Body={config.gvr.ErrMsgs.MsgNotFound}/>});
            });  
        }
        else
        {
            this.setState({ErrMsg:<ModalLogin mTitle={config.gvr.ErrMsgs.TitleNotLoggedin} mBody={config.gvr.ErrMsgs.MsgNotLoggedin}/>});
        }

    }
    render(){
        let isLoaded = this.state.isLoaded;
        let items = this.state.myitems;    
        let leavedetail="",ardetail="",revoke="",revokepart="",remove="",artext="";
        let todate=new Moment();
        let statustext = [];
        //console.log(items);
        if (!isLoaded) 
        {
            return(
            <div className="container12">
              <div className="center">
                {this.state.ErrMsg}
              </div>
          </div>
            );
        } 
        else 
        {
            return(
            <div className="container1">
                <br></br>                             
            {/*}    <span className="box-title">Leave application detail </span>
                <br></br>*/}                    <br></br>
                <div style={{width:"100%",paddingTop:"40px",align:"center"}} >
                <div className="inner-profile" >
                <h5 style={{textAlign:"center"}}>Leave Application Form</h5>

                <table style={{width:"100%",paddingLeft:"1%",paddingTop:"10px", left:"50%", margin:"0 auto"}}>
                    <thead>
                    <tr className="tr">
                        <th className="th" scope="col">Reference</th>
                        <th className="th" scope="col">Application date</th>
                        <th className="th" scope="col">Leave from</th>
                        <th className="th" scope="col">Leave to</th>
                        <th className="th" scope="col">Leave days</th>
                        <th className="th" scope="col">Leave detail</th>
                        <th className="th" scope="col">Status</th>
                        <th className="th" scope="col" colSpan={2}>Revoke</th>
                        <th className="th" scope="col" colSpan={2}>Action</th>


                    </tr>
                    </thead>
                    <tbody>
                    {
                    items.map((result ,i) => {
//                        this.state.statustext.slice();
                        ardetail="";
                        revoke="";
                        remove="";
                        revokepart="";
                        artext="";
                        todate=new Date(result.to_date);

                        if(result.leavedays > 0 && result.lwp > 0)
                            leavedetail= result.leavetype+" = "+result.leavedays+", LWP = "+result.lwp;
                        if(result.leavedays > 0 && result.lwp == 0)
                            leavedetail= result.leavetype+" = "+result.leavedays;
                        if(result.leavedays == 0 && result.lwp > 0)
                            leavedetail= "LWP = "+result.lwp;
                        if(result.lstatus == null || result.lstatus == -1)
                        {
                            ardetail = <span id={result.id} style={{color:'black'}}>pending... </span>;
                            revoke = <button type='btn' style={{width:60}} onClick={() => {this.handlerevoke(result.id, i)}}>All</button>;    

                            revokepart ="";

                        }
                        else if(result.lstatus == 1 )
                        {

//                            artext="Approved on "+Moment(result.ardate).format("DD/MM/YYYY");
                            ardetail = <span id={result.id} style={{color:'green'}}>Approved on {Moment(result.ardate).format("DD/MM/YYYY")}</span>;
                            if(result.DateDiff < 7)
                                remove = <button type='btn' style={{width:60}} onClick={() => {this.handlecancel(result.id, i)}}>Cancel</button>;    
                            else
                                remove = ""; //<button type='btn' style={{width:60}} onClick={() => {this.handlecancel(result.id, i)}}>Cancel</button>;    

                            if(todate.getTime() > this.state.today.getTime() && (result.leavetype=='Annual' || result.leavetype=="Sick"))
                            {
    
                                revokepart = <button type='btn' style={{width:60}} onClick={() => {this.handlerevokepartial(result.id, i)}}>Partial</button>;
                            }

                             revoke = "";
//                             remove="";
                        }
                        else if(result.lstatus == 2 )
                        {
                            ardetail = <span  id={result.id} style={{color:'red'}}>Refused on {Moment(result.ardate).format("DD/MM/YYYY")}</span>;
                            revokepart = "";
                            revoke = "";
                            remove = "";

                        }
                        else if(result.lstatus == 3 )
                        {
                            ardetail = <span id={result.id} style={{color:'blue'}}>Revoked on {Moment(result.ardate).format("DD/MM/YYYY")}</span>;
                            remove = <button type='btn' style={{width:60}} onClick={() => {this.handleremove(result.id, i)}}>Remove</button>;    

                             revoke = "";
//                             remove= "";
                             revokepart ="";
                        }
                        else if(result.lstatus == -4 )
                        {
                            ardetail = <span  id={result.id} style={{color:'red'}}>Cancellation pending </span>;
                            revokepart = "";
                            revoke = "";
                            remove = <button type='btn' style={{width:60}} onClick={() => {this.handlecancel(result.id, i)}}>Resend</button>;    

//                            remove = "";

                        }
                        else if(result.lstatus == 4 )
                        {
                            ardetail = <span  id={result.id} style={{color:'red'}}>Cancelled </span>;
                            revokepart = "";
                            revoke = "";
                            remove = "";

                        }

                        this.state.statustext.push(ardetail);    
                        this.state.revoke.push(revoke);                 
                        this.state.revokepart.push(revokepart);                 
                        this.state.remove.push(remove);
                        return(
                            <tr className="trc" key={i}>
                                <td className="tdm" >{result.id}</td>
                                <td className="tdm">{Moment(result.applieddate).format("DD/MM/YYYY")}</td>
                                <td className="tdm">{Moment(result.from_Date).format("DD/MM/YYYY")}, {result.from_time}</td>
                                <td className="tdm">{Moment(result.to_date).format("DD/MM/YYYY")}, {result.to_time}</td>
                                <td className="tdm">{Number(result.leavedays)+Number(result.lwp)} day/s</td>
                                <td className="tdm">{leavedetail}</td>
                                <td className="tdm">{this.state.statustext[i]}</td>
                                <td className="tdm" colSpan={2}>{this.state.revoke[i]}{this.state.revokepart[i]}</td>
                                <td className="tdm" colSpan={2}>{this.state.remove[i]}</td>
{/*}                                <td className="tdm">{this.state.revokepart[i]}</td>*/}
                            </tr>
                        )
                        
                    })}

                    </tbody>
                </table>
                </div>
                </div>
            </div>
        );
    }
}}